import Box from '@mui/material/Box';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Stepper from '@mui/material/Stepper';
import * as React from 'react';

interface HorizontalStepperProps {
  steps: string[]
  children: React.ReactNode
  activeStep: number
}

export default function HorizontalStepper({
  steps,
  children,
  activeStep,
}: HorizontalStepperProps) {

  return (
    <Box sx={{ width: '100%' }}>
      <Stepper activeStep={activeStep}>
        {steps.map((label, index) => {
          const stepProps: { completed?: boolean } = {};
          const labelProps: {
            optional?: React.ReactNode;
          } = {};
          return (
            <Step key={label} {...stepProps}>
              <StepLabel {...labelProps}>{label}</StepLabel>
            </Step>
          );
        })}
      </Stepper>
      {activeStep === steps.length ? 
        <>
          <div style={{ marginTop: '2px', marginBottom: '1px' }}>
            {children && Array.isArray(children) && children[activeStep] }
          </div>
        </>
      :
        <>
          <div style={{ marginTop: '2px', marginBottom: '1px' }}>
            {children && Array.isArray(children) &&
              children.map((child, index: number) => {
                if (index === activeStep) {
                  return child
                }
                return null
              })}
          </div>
        </>
      }
    </Box>
  );
}
